// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MessagePage_wrapper__yphsy","title":"MessagePage_title__DVsuN","returnLink":"MessagePage_returnLink__K12G0"};